import { ChatAssistant } from '../../types'

import styles from './SupportStubAssistantGreetingCard.module.scss'

export type SupportGreetingCardProps = {
  assistant: ChatAssistant
}

export default function SupportGreetingCard({ assistant }: SupportGreetingCardProps) {
  const firstName = assistant.userName ? assistant.userName.split(' ', 2)[0] : ''

  return (
    <div className={styles.SupportStubAssistantGreetingCard}>
      <div className={styles.SupportStubAssistantGreetingCard__icon}>👋</div>
      <div className={styles.SupportStubAssistantGreetingCard__content}>
        <div className={styles.SupportStubAssistantGreetingCard__title}>
          Hi there{firstName ? `, ${firstName}` : ''}!
        </div>
        <div className={styles.SupportStubAssistantGreetingCard__text}>
          Our team is standing by — just send a message to get started
        </div>
      </div>
    </div>
  )
}
